// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3PXBs","alert":"SettungsInbox_alert__2xxW2"};